import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./actions";
import * as API from "./services/api";
import { Route, Switch, withRouter } from "react-router-dom";
import routes from "./routes";
import Loading from "./components/loading";
import "./App.less";

class App extends Component {
  componentDidMount() {
    const { history } = this.props;

    this.props.setRoute(history.location.pathname);
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);

      const path = history.location.pathname
        ? history.location.pathname.split("/")
        : "";
      this.props.setRoute("/" + path[1]);
    });
  }

  componentWillReceiveProps(nextProps) {
    const m = nextProps.route.match(/^\/([^/]+)/);
    document.body.className = m && m[1];
    if (nextProps.route !== "/login" && nextProps.route !== this.props.route) {
      this.checkAdminInfo();
    }
  }

  checkAdminInfo = () => {
    const token = API.tokenStorage.get();
    if (token && token.length && token !== "null") {
      API.getAdminProfile()
        .then((result) => {
          // Login Success
          if (result.status) {
            this.props.setAdminInfo(result.data);
          } else {
            this.props.logout();
          }
        })
        .catch(() => {
          this.props.logout();
        });
    } else {
      this.props.history.push("/login");
    }
  };

  render() {
    return (
      <div className="app">
        <section className="content">
          <Switch>
            {routes.map((route, i) => (
              <Route {...route} key={i} />
            ))}
          </Switch>
        </section>

        <Loading />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    route: state.route,
    isLoggedIn: state.isLoggedIn,
    isLoading: state.isLoading,
  }),
  (dispatch) => bindActionCreators({ ...actions }, dispatch)
)(withRouter(App));
